
import { invoiceRequest } from '@services'
import { isSpecialTicket, isAllElectric, onCount, deepCopy } from '@utils/basicUtil'
import { Notify } from 'vant'
export default {
  namespaced: true,
  state: {
    invoiceInfo: {},
    applicationType: '1',
    redReason: '1'
  },
  actions: {
    async redOffsetInvoice ({ commit, state }) {
      const { redReason, invoiceInfo: { id, invoiceType, remark } } = state
      const res = await invoiceRequest.apply.redInvoice({
        id,
        remark,
        redReason,
        invoiceType
      })
      if (res.success) {
        Notify({ type: 'success', message: '红字发票开具请求已提交！' })
      } else {
        Notify({ type: 'danger', message: res.message || '操作异常' })
      }
    },
    async getInvoiceInfo ({ commit, state }) {
      const { invoiceCode, invoiceNo } = state.invoiceInfo
      const res = await invoiceRequest.apply.getInvoiceInfByCodyNo({
        invoiceNo,
        invoiceCode
      })
      if (res.success && res.result) {
        // 如果是专票 || 数电直接弹窗, 因为没有红字信息表
        if (isSpecialTicket(res.result.invoiceType) || isAllElectric(res.result.invoiceType)) {
          return { showDialog: true }
        }

        res.result.amountWithTax = -1 * res.result.amountWithTax
        res.result.taxAmount = -1 * res.result.taxAmount
        res.result.amount = -1 * res.result.amount
        let details = deepCopy(res.result.details)
        let index = 1
        details.forEach((v) => {
          if (v.invoiceLineType !== 1) {
            v.order = index++
          }
          v.unitPriceTax = onCount.add(v.unitPrice, v.taxAmount / v.quantity)
          // 普票红冲的时候，金额是正的，需要乘以负数
          v.amountWithTax = -1 * v.amountWithTax.toFixed(2)
          v.amount = v.amount * -1
          v.taxAmount = v.taxAmount > 0 ? v.taxAmount * -1 : v.taxAmount
          v.quantity = v.quantity * -1
          v.price = v.unitPriceTax
          if (v.invoiceLineType === 1) {
            v.count = ''
            v.priceTax = ''
            v.price = ''
          }
        })
        details.forEach((line, i, array) => {
          if (line.invoiceLineType === 2 && array[i + 1] && array[i + 1].invoiceLineType === 1) {
            line.amount += array[i + 1].amount
            line.amount = line.amount.toFixed(2)
            line.taxAmount -= array[i + 1].taxAmount
            line.taxAmount = line.taxAmount.toFixed(2)
            line.amountWithTax = onCount.add(Number(line.amount), Number(line.taxAmount))
            line.amountWithTax = line.amountWithTax.toFixed(2)
            if (line.quantity) {
              const convertPrice = (price) => {
                const priceStr = String(price)
                if (priceStr.length > 15) {
                  return priceStr.substr(0, 15)
                }
                return price
              }
              line.unitPrice += array[i + 1].amount / line.quantity // 单价不含税
              line.unitPrice = convertPrice(line.unitPrice)
              line.unitPriceTax += array[i + 1].amountWithTax / line.quantity // 单价含税
              line.unitPriceTax = convertPrice(line.unitPriceTax)
              line.price = line.amountWithTax / line.quantity
            } else {
              line.unitPrice = '' // 单价不含税
              line.unitPriceTax = '' // 单价含税
              line.price = '' // 单价含税
              line.quantity = ''
            }
          }
        })
        details = details.filter(line => (line.invoiceLineType !== '1' && line.invoiceLineType !== 1) && (Number(line.amount || 0) !== 0))
        await commit('setInvoiceInfo', {
          ...res.result,
          details,
          drewDate: res.result.drewDate ? res.result.drewDate.split(' ')[0] : res.result.drewDate
        })
        return true
      } else {
        Notify({ type: 'danger', message: res.message || '数据异常' })
      }
    }
  },
  mutations: {
    setInvoiceInfoByField (state, { field, value }) {
      state.invoiceInfo = {
        ...state.invoiceInfo,
        [field]: value
      }
    },
    initInvoiceRedInfo (state) {
      state.invoiceInfo = {}
      state.applicationType = '1'
      state.redReason = '1'
    },
    setInvoiceInfo (state, invoiceInfo) {
      state.invoiceInfo = invoiceInfo
    },
    setApplicationType (state, applicationType) {
      console.log(applicationType)
      state.applicationType = applicationType
    },
    setRedReason (state, redReason) {
      state.redReason = redReason
    }
  }
}
